import { COMMON_CONSTS } from '../common/common.consts'

export const SEARCH_CONSTS = {
  moduleName: 'epb-search',

  getters: {},
  actions: {
    ...COMMON_CONSTS.actions,
    search: 'search',
    browse: 'browse',
  },
  mutations: {
    ...COMMON_CONSTS.mutations,
  },
}
